import React from 'react';
import cx from 'classnames';
import {Modal, Slide} from '@mui/material';
import Div100vh from 'src/components/div100vh';
import {Backdrop} from 'src/components/backdrop';
import {CartView} from 'src/components/cart/view';
import {useStoreContext, useToggleCart} from 'src/context/storeContext';

import {ReactComponent as X} from 'src/images/svg/X.svg';

import * as styles from './drawer.module.css';

export const CartDrawer = () => {
	const {cartIsOpen, noticeBarVisible} = useStoreContext();
	const toggleCart = useToggleCart();

	return (
		<Modal
			open={cartIsOpen}
			onClose={() => toggleCart()}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{active: cartIsOpen, toggle: toggleCart}}
			aria-modal="true"
			aria-labelledby="cartLabel">
			<Slide
				direction="left"
				in={cartIsOpen}
				timeout={{
					enter: 500,
					exit: 250,
				}}>
				<div
					className={cx(
						styles.cartDrawer,
						noticeBarVisible ? styles.noticeBarVisible : '',
					)}>
					<Div100vh className={cx(styles.cartViewContainer)}>
						<button
							className={cx('reset', styles.closeButton)}
							onClick={toggleCart}>
							<X />
						</button>
						<CartView />
					</Div100vh>
				</div>
			</Slide>
		</Modal>
	);
};
